import { render, staticRenderFns } from "./mechanismOrderList.vue?vue&type=template&id=fb3b6d8e&scoped=true"
import script from "./mechanismOrderList.vue?vue&type=script&lang=js"
export * from "./mechanismOrderList.vue?vue&type=script&lang=js"
import style0 from "./mechanismOrderList.vue?vue&type=style&index=0&id=fb3b6d8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3b6d8e",
  null
  
)

export default component.exports